import { Injectable } from '@angular/core';
import { DefaultService } from '@psnb/psnb-api';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class PowerSupplyBulkUploadService {
  powerSupply: any = {};

  constructor(private powerSupplyService: DefaultService) {
  }

  getPowerSupplyBulkUploadStatus() {
    return this.powerSupplyService.powerSupplyBulkUploadStatus().pipe(map(res => res));
  }

  getPSBatteryBulkUploadStatus() {
    return this.powerSupplyService.powerSupplyBatteryBulkUploadStatus().pipe(map(res => res));
  }

  getPSSpatialnetBulkUploadStatus() {
    return this.powerSupplyService.powerSupplySpatialNetBulkUploadStatus().pipe(map(res => res));
  }

  getPSTemplate() {
    return this.powerSupplyService.getPSTemplate().pipe(map(res => res));
  }

  powerSupplyBulkUpload(bulkUploads) {
    return this.powerSupplyService.powerSupplyBulkUpload(bulkUploads).pipe(map(res => res));
  }

  getBatteryTemplate() {
    return this.powerSupplyService.getBatteryTemplate().pipe(map(res => res));
  }

  batteryBulkUpload(bulkUploads) {
    return this.powerSupplyService.batteryBulkUpload(bulkUploads).pipe(map(res => res));
  }

  getSpatialNetTemplate() {
    return this.powerSupplyService.getSpatialNetTemplate().pipe(map(res => res));
  }

  spatialNetBulkUpload(bulkUploads) {
    return this.powerSupplyService.uploadSpatialNetData(bulkUploads).pipe(map(res => res));
  }

}
